import MuiFormControl, { type FormControlProps as MuiFormControlProps } from '@mui/material/FormControl'
import MuiFormLabel, { type FormLabelProps as MuiFormLabelProps } from '@mui/material/FormLabel'
import MuiFormControlLabel, {
  type FormControlLabelProps as MuiFormControlLabelProps,
} from '@mui/material/FormControlLabel'
import MuiFormHelperText, { type FormHelperTextProps as MuiFormHelperTextProps } from '@mui/material/FormHelperText'
import MuiInputLabel, { type InputLabelProps as MuiInputLabelProps } from '@mui/material/InputLabel'
import MuiMenuItem, { type MenuItemProps as MuiMenuItemProps } from '@mui/material/MenuItem'
import MuiRadioGroup, { type RadioGroupProps as MuiRadioGroupProps } from '@mui/material/RadioGroup'
import MuiRadio, { type RadioProps as MuiRadioProps } from '@mui/material/Radio'
import MuiSelect, {
  type SelectProps as MuiSelectProps,
  type SelectChangeEvent as MuiSelectChangeEvent,
} from '@mui/material/Select'
import MuiTextField, { type TextFieldProps as MuiTextFieldProps } from '@mui/material/TextField'
import MuiOutlinedInput, { type OutlinedInputProps as MuiOutlinedInputProps } from '@mui/material/OutlinedInput'
import MuiInputAdornment, { type InputAdornmentProps as MuiInputAdornmentProps } from '@mui/material/InputAdornment'
import MuiAutocomplete from '@mui/material/Autocomplete'
import MuiSwitch from '@mui/material/Switch'

//* FORM CONTROL
export const FormControl = MuiFormControl
export type FormControlProps = MuiFormControlProps

//* FORM LABEL
export const FormLabel = MuiFormLabel
export type FormLabelProps = MuiFormLabelProps

//* FORM CONTROL LABEL
export const FormControlLabel = MuiFormControlLabel
export type FormControlLabelProps = MuiFormControlLabelProps

//* FORM HELPER TEXT
export const FormHelperText = MuiFormHelperText
export type FormHelperTextProps = MuiFormHelperTextProps

//* INPUT LABEL
export const InputLabel = MuiInputLabel
export type InputLabelProps = MuiInputLabelProps

//* MENU ITEM
export const MenuItem = MuiMenuItem
export type MenuItemProps = MuiMenuItemProps

//* RADIO GROUP
export const RadioGroup = MuiRadioGroup
export type RadioGroupProps = MuiRadioGroupProps

//* RADIO
export const Radio = MuiRadio
export type RadioProps = MuiRadioProps

//* SELECT
export const Select = MuiSelect
export type SelectProps = MuiSelectProps
export type SelectChangeEvent = MuiSelectChangeEvent

//* TEXT FIELD
export const TextField = MuiTextField
export type TextFieldProps = MuiTextFieldProps

//* OUTLINED INPUT
export const OutlinedInput = MuiOutlinedInput
export type OutlinedInputProps = MuiOutlinedInputProps

//* INPUT ADORNMENT
export const InputAdornment = MuiInputAdornment
export type InputAdornmentProps = MuiInputAdornmentProps

//* AUTOCOMPLETE
export const Autocomplete = MuiAutocomplete

//* SWITCH
export const Switch = MuiSwitch
